module.exports = [{
      plugin: require('/var/www/clients/client2/web21/web/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Leda Homecare","short_name":"Leda","start_url":"/","background_color":"#BDEDEB","theme_color":"#BDEDEB","display":"minimal-ui","icon":"src/images/favicon.png"},
    },{
      plugin: require('/var/www/clients/client2/web21/web/node_modules/gatsby-plugin-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-150917070-1","head":true},
    }]
